export default "__VITE_ASSET__DEeAWOas__"